module.exports = __webpack_public_path__ + "media/images/placeholder-review-avatar-e8968964c3a884ce846ec5dbf4c6f597.png";